import EFLight from '@elem/ui-assets/icons/appliances/EFLight';
import EFPhone from '@elem/ui-assets/icons/appliances/EFPhone';
import EFProjector from '@elem/ui-assets/icons/appliances/EFProjector';
import EFMiniFridge from '@elem/ui-assets/icons/appliances/EFMiniFridge';
import EFCoffeeMaker from '@elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFElectricGrill from '@elem/ui-assets/icons/appliances/EFElectricGrill';

import EFCarFridge from '@elem/ui-assets/icons/appliances/EFCarFridge';
import EFMicrowave from '@elem/ui-assets/icons/appliances/EFMicrowave';
import EFAirConditioner from '@elem/ui-assets/icons/appliances/EFAirConditioner';
import EFElectricBlanket from '@elem/ui-assets/icons/appliances/EFElectricBlanket';

import EFRefrigerator from '@elem/ui-assets/icons/appliances/EFRefrigerator';
import EFLaptop from '@elem/ui-assets/icons/appliances/EFLaptop';

export default function GetAppIcon({ appliance }: { appliance: string }) {
    const iconMap: { [key: string]: JSX.Element } = {
        Light: <EFLight />,
        Phone: <EFPhone />,
        Projector: <EFProjector />,
        MiniFridge: <EFMiniFridge />,
        CoffeeMaker: <EFCoffeeMaker />,
        ElectricGrill: <EFElectricGrill />,
        CarFridge: <EFCarFridge />,
        Microwave: <EFMicrowave />,
        AirConditioner: <EFAirConditioner />,
        ElectricBlanket: <EFElectricBlanket />,
        Refrigerator: <EFRefrigerator />,
        Laptop: <EFLaptop />,
    };
    return iconMap[appliance] || <></>;
}
